import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { LookInside } from './components/LookInside';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { shortTestimonials, moreTestimonials } from './data/testimonials';
export function App() {
  return <div className="min-h-screen w-full bg-plum text-white font-sans selection:bg-gold selection:text-gold-ink" data-id="element-0" data-mp="3ijfvu1ti80fo">
      <MetaPixel data-id="element-1" data-mp="3mjq45l4rr2xp" />
      <main data-id="element-2" data-mp="3mj6jhwnqi0fz">
        <Hero data-id="element-3" data-mp="3rcj6y3gog175" />
        <SocialProofBar data-id="element-4" data-mp="3rbrcwx2qabiz" />
        <PainGrid data-id="element-5" data-mp="3rdkh85pvcjnt" />
        <ProductReveal data-id="element-6" data-mp="3rd18nfm3z7mg" />
        <Tomes data-id="element-7" data-mp="5yj0slx59ec" />
        <Bonuses data-id="element-8" data-mp="6hqffdy0fe4" />
        <LookInside data-id="element-9" data-mp="4wvhonpuufq" />
        <ValueStack data-id="element-10" data-mp="5ggje8nxyxz" />
        <Urgency data-id="element-11" data-mp="82j0zgp5o9c" />
        <Pricing data-id="element-12" data-mp="2zl3cjn8vpa6d" />
        <Testimonials testimonials={shortTestimonials} background="white" data-id="element-13" data-mp="2zlld2w2kqak3" />
        <Guarantee data-id="element-14" data-mp="33mow1rfx4mpj" />
        <Faq data-id="element-15" data-mp="33m5c656pjo8v" />
        <Testimonials testimonials={moreTestimonials} title="More rooms, more weeks" background="blush" data-id="element-16" data-mp="33nq73vwxp979" />
        <CostOfInaction data-id="element-17" data-mp="38nupxslbeg0n" />
        <Close data-id="element-18" data-mp="3dkl58dpap7l0" />
      </main>
      <Footer data-id="element-19" data-mp="3dlw5i3jj7x7d" />
      <PurchaseNotifications data-id="element-20" data-mp="3dmfprqwnmxok" />
    </div>;
}